import "./client-header-create.css";
import NewChangesTabs from "../new-client-dashboard/NewChangesTabs";
import TabsComponentNotesLevel from "../TreatmentPage/TabsComponentNotesLevel";

function CreateNewClientHeader({ sidebarItems, activeTab, handleTabChange, isMain = false }) {
  if (isMain) {
    const mainTabs = sidebarItems
      .filter((item) => item.id !== "intake-reporting")
      .map((item) => ({
        id: item.id,
        label: item.name,
        onClick: () => handleTabChange(item.id),
      }));

    const intakeReportingTab = sidebarItems
      .filter((item) => item.id === "intake-reporting")
      .map((item) => ({
        id: item.id,
        label: item.name,
        onClick: () => handleTabChange(item.id),
      }));

    return (
      <div className="create-client-main-tabs">
        <div className="create-client-main-tabs-left">
          <TabsComponentNotesLevel
            handlePage={activeTab}
            tabsData={mainTabs}
            labelClass="ps-0"
            controlledActiveTab
          />
        </div>

        <div
          className="create-client-main-tabs-right"
          style={{
            right: "-8px",
          }}
        >
          <TabsComponentNotesLevel
            handlePage={activeTab}
            tabsData={intakeReportingTab}
            labelClass="justify-content-end pe-0"
            controlledActiveTab
          />
        </div>
      </div>
    );
  }

  return (
    <NewChangesTabs
      currentTab={activeTab}
      tabsData={sidebarItems}
      height={25}
      labelClass=" justify-content-start pe-2"
    />
  );
}

export default CreateNewClientHeader;
